module.exports = __webpack_public_path__ + "static/media/cart-restaurant.a963b644.svg";